import React from "react";
import Radium from "radium";
import { Link } from "react-router";

import EventStore from "../../../stores/EventStore";

import TicketButton from "../ticket-button.jsx";
import FilmPoster from "../film-poster.jsx";
import { makeFilmDetailString } from "../../../util";

const MarqueeListEntry = ({
  id,
  showings = {},
  films = {},
  events = {},
  inlineOnFilm = false,
  isMultipleEntries = false,
  film
}) => {
  if (inlineOnFilm) {
    id = film.id;
    films = { [id]: film };
  }

  const ids = id.split("|"),
    entries = ids.map(i => films[i] || events[i]);

  if (entries.some(entry => typeof entry === "undefined" || entry === "undefined")) {
    return <text>Invalid Entry</text>
  }

  const featuredEntry = entries.find(f => !!f.poster_image) || entries[0],
    poster = featuredEntry.poster_image || featuredEntry.cover_image,
    title = entries.map(e => e.name).join(" & ");

  const linkDestination = {
    pathname: `/${events[featuredEntry.id] ? "schedule" : "films"}/${
      featuredEntry.id
    }`,
    state: { fromSchedule: true }
  };

  return (
    <div
      style={
        !inlineOnFilm
          ? [styles.container, isMultipleEntries && styles.containerForMultiple]
          : null
      }
    >
      {!inlineOnFilm ? (
        <Link style={{ alignSelf: "flex-start" }} to={linkDestination}>
          <FilmPoster
            style={styles.poster}
            backgroundSrc={poster}
            showInnerOnHover={false}
          >
            {!poster && (
              <h1 style={{ padding: "1em", lineHeight: 1 }}>{title}</h1>
            )}
          </FilmPoster>
        </Link>
      ) : null}
      <div style={!inlineOnFilm ? styles.detail : null}>
        {!inlineOnFilm ? (
          <div>
            <h1 style={styles.title}>
              <Link to={linkDestination} style={styles.title}>
                {title}
              </Link>
            </h1>
            {featuredEntry.details ? (
              <h2 style={styles.subtitle}>
                {makeFilmDetailString(featuredEntry.details)}
              </h2>
            ) : null}
            <div style={styles.description}>
              {featuredEntry.short_description}{" "}
              <Link
                style={{ fontStyle: "initial", color: "rgb(62, 62, 62)" }}
                to={linkDestination}
              >
                More details...
              </Link>
            </div>
          </div>
        ) : null}
        <div style={styles.showings}>
          {Object.keys(showings)
            .sort()
            .map(venue => {
              return (
                <div key={venue}>
                  <h3 style={styles.venue}>
                    {venue === "undefined" ? "Unknown Venue" : venue}
                  </h3>
                  <div style={{ margin: -5 }}>
                    {showings[venue]
                      .sort((a, b) => a.start_time.localeCompare(b.start_time))
                      .map((event, i) => {
                        return (
                          <div
                            key={event.id}
                            style={{ margin: 5, display: "inline-block" }}
                          >
                            <TicketButton
                              key={event.id}
                              event={EventStore.getEventById(event.id) || event}
                              onMarquee={true}
                              forceLabel={event.start_time_label}
                              fromSchedule={true}
                              fromFilmId={inlineOnFilm ? film.id : false}
                              inline={true}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Radium(MarqueeListEntry);

const styles = {
  poster: {
    minWidth: 150,
    width: 150,
    height: 225,
    "@media (max-width: 992px)": {
      marginLeft: "2em"
    }
  },
  container: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: 30,
    color: "rgb(62, 62, 62)",
    flexBasis: 480,
    flexGrow: 1
  },
  containerForMultiple: {
    "@media (min-width: 960px)": {
      maxWidth: 480
    }
  },
  detail: {
    width: "100%",
    paddingLeft: "2em",
    paddingRight: "2em",
    minHeight: 225,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  title: {
    color: "rgb(62, 62, 62)",
    textDecoration: "none",
    margin: 0,
    fontSize: 18,
    fontWeight: "bold",
    ":hover": {
      cursor: "pointer",
      textDecoration: "underline"
    }
  },
  subtitle: {
    color: "#757575",
    fontSize: 15,
    margin: "0.25em 0 0"
  },
  description: {
    fontSize: "15px",
    lineHeight: "22px",
    fontStyle: "italic",
    margin: "0.75em 0 0"
  },
  venue: {
    margin: "0.75em 0 0.5em",
    fontSize: 15
  },
  button: {
    display: "inline-block"
  }
};



// WEBPACK FOOTER //
// ./src/app/components/partials/marquee/marquee-list-entry.jsx